module.exports = __webpack_public_path__ + "static/media/arizona-removebg-preview.2f48d49b.png";